import React, {Fragment} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import ShippingDetailHeader from './ShippingDetailHeader';
import ShippingDetailToolbar from './ShippingDetailToolbar';
import { Avatar, CircularProgress, Grid, IconButton, TextField} from '@material-ui/core';
import ShippingItemDetails from '../ShippingItemDetails';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import {blue} from '@material-ui/core/colors';
import {Row} from "antd";
import {nanoid} from "@reduxjs/toolkit";
import {isEmpty} from "lodash";
import useContainerDetails from "../../../hooks/useContainerDetails";
import {useDispatch} from "react-redux";
import {setNewArivals} from "../../../redux/slices/container_details";
import {LoadingButton} from "@mui/lab";

//#region SORT AND COMPARE
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

//#endregion


function TableCellDetils() {
    const [open, setopen] = React.useState(false);

    const handleChange = () => {
        setopen(!open);
    }

    return !open ?
        <IconButton onClick={handleChange}>
            <KeyboardArrowDownIcon/>
        </IconButton> :
        <IconButton onClick={handleChange}>
            <KeyboardArrowUpIcon/>
        </IconButton>
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    cellFont: {
        fontSize: 12,
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    }
}));

export default function ShippingDetailList({data = [], shippingId, isLoading = false, containerCode}) {

//#region STATE 
    const classes = useStyles();
    const [rows, setRows] = React.useState(data);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [Loading, setLoading] = React.useState(false);
    const [dense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(15);
    const [detailItem, setDetailsItem] = React.useState(null);
    const [showDetailsItem, setShowDetailsItem] = React.useState(false);
    const [filters, setFilter] = React.useState({name: '', bcode: '', prosoft: '', expdate: ''})
    const [expand, setExpand] = React.useState(null);
    const {grouped} = useContainerDetails(containerCode);
    const dispatch = useDispatch();

    const handleNewArrivage = () => {
        setLoading(true);
        dispatch(setNewArivals(grouped,()=>setLoading(false)))
    }

//#endregion

//#region FILTER
    const handleFilterChange = (e) => {
        //console.log("object ==> "+ e.target.value);
        setFilter({[e.target.name]: e.target.value});
    }

    const handleExpandTableCell = (index) => {
        setExpand(expand === index ? null : index);
    }


    React.useEffect(() => {
        let toFilter = [...data] || []
        console.log(data)
        //console.log("NONO ==> 5");
        let searchFilter = []

        if (!isEmpty(filters.name)) {
            let resName = []
            toFilter.forEach((item) => {
                const my_data = item[1][0]

                if (my_data.ProductName?.trim().toString().toUpperCase().includes(filters.name?.toUpperCase())) {
                    resName.push(item)
                    searchFilter = resName;

                }

            })
        }

        if (!isEmpty(filters.bcode)) {
            const resBarCode = []
            toFilter.forEach((item) => {
                const bareCode = item[1][0]

                if (bareCode.ProductBarcode?.trim().toUpperCase().includes(filters.bcode?.toUpperCase())) {
                    resBarCode.push(item)
                    searchFilter = resBarCode;
                }

            })
        }

        if (!isEmpty(filters.prosoft)) {
            const resId = []
            toFilter.forEach((item) => {
                const my_id = item[1][0]
                if (my_id.InternalId?.trim().toString().toUpperCase().includes(filters.prosoft?.toUpperCase())) {
                    resId.push(item)
                    searchFilter = resId;
                }
            })
        }

        // const resExpDate = []
        // toFilter.forEach((item)=>{
        //     const my_date = item[1][0]
        //     if(my_date.ExpirationDate?.trim().toString().toUpperCase().includes(filters.expdate?.toUpperCase())){
        //         resExpDate.push(item)
        //         searchFilter = resExpDate;
        //     }
        // })

        const isFilterEmpty = isEmpty(filters.name) && isEmpty(filters.bcode) && isEmpty(filters.prosoft);

        setRows(isFilterEmpty ? data : searchFilter)
        // console.log('data', toFilter)

    }, [filters, data])
//#endregion

//#region FUNCTION


    const handleShowDetailItem = (item) => {
        setDetailsItem(item);
        setShowDetailsItem(true);
    }


    const handleCloseDetailItem = () => {
        setShowDetailsItem(false)
        setDetailsItem(null)
    }

    const toolBselectItem = React.useCallback((data) => {
        let tab = []
        selected.forEach((e) => {
            const exist = data.find(([_, r]) => r[0].id === e);
            if (exist) {
                tab.push(exist[1][0]);
            }
        });
        return tab;

    }, [selected])


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map(([_, n]) => n[0].id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const handleCellClick = (event, item) => {
        handleShowDetailItem(item)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // const handleChangeDense = (event) => {
    //     setDense(event.target.checked);
    // };


    const textMaxSize = React.useCallback((text) => {
        const btext = text?.length > 60 ? text.substring(0, 59) + '...' : text

        return btext
    }, [])


    const isSelected = (id) => selected.indexOf(id) !== -1;

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
//#endregion



    return (
        <div className={classes.root}>

            <LoadingButton loading={Loading} variant={"contained"} color={"primary"} onClick={handleNewArrivage} style={{margin: 10}}>
                Mettre en page de noveau arivage
            </LoadingButton>


            <Paper className={classes.paper}>

                <ShippingDetailToolbar numSelected={selected.length}
                                       setSelected={setSelected}
                                       shippingId={shippingId}
                                       selectedItem={toolBselectItem(rows)}/>

                <Grid container spacing={2} style={{padding: 20}}>
                    <Grid item> <TextField margin="dense" variant="outlined" name="name" value={filters.name}
                                           onChange={handleFilterChange} label="chercher par nom"/> </Grid>
                    <Grid item> <TextField margin="dense" variant="outlined" name="bcode" value={filters.bcode}
                                           onChange={handleFilterChange} label="chercher par code barre"/> </Grid>
                    <Grid item> <TextField margin="dense" variant="outlined" name="prosoft" value={filters.prosoft}
                                           onChange={handleFilterChange} label="chercher par Prosoft id"/> </Grid>

                </Grid>

                {showDetailsItem && detailItem &&
                <ShippingItemDetails onClose={handleCloseDetailItem} title="Details" Item={detailItem}/>}

                {
                    isLoading && (
                        <Row justify='center'>
                            <CircularProgress size={200}/>
                        </Row>
                    )
                }

                {
                    !isLoading && (
                        <>
                            <TableContainer>
                                <Table
                                    className={classes.table}
                                    aria-labelledby="tableTitle"
                                    size={dense ? 'small' : 'medium'}
                                    aria-label="enhanced table"

                                >
                                    <ShippingDetailHeader
                                        classes={classes}
                                        numSelected={selected.length}
                                        order={order}
                                        orderBy={orderBy}
                                        onSelectAllClick={handleSelectAllClick}
                                        onRequestSort={handleRequestSort}
                                        rowCount={rows.length}
                                    />

                                    <TableBody>
                                        
                                        {

                                            stableSort(rows, getComparator(order, orderBy))
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map(([key, tabRow], index) => {


                                                    let row = {...tabRow[0]}
                                                    row.Quantity = 0;

                                                    tabRow.forEach((item) => {
                                                        row.Quantity += item.Quantity;
                                                    });

                                                    const isItemSelected = isSelected(row.id);
                                                    const labelId = `enhanced-table-checkbox-${index}`;

                                                    return (
                                                        <Fragment key={key}>
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                aria-checked={isItemSelected}
                                                                tabIndex={-1}
                                                                key={key}
                                                                selected={isItemSelected}
                                                            >
                                                                <TableCell padding="checkbox"
                                                                           onClick={(event) => handleClick(event, row.id)}>
                                                                    {tabRow.length === 1 && <Checkbox
                                                                        checked={isItemSelected}
                                                                        inputProps={{'aria-labelledby': labelId}}
                                                                    />}
                                                                </TableCell>
                                                                <TableCell align="left" className={classes.cellFont}>
                                                                    <Grid container>
                                                                        <Grid item xs={11} container
                                                                              onClick={(e) => handleCellClick(e, row)}>
                                                                            <Grid item>
                                                                                {row.ProductImageUrl ?
                                                                                    <Avatar alt={row.ProductName}
                                                                                            src={row.ProductImageUrl}/> :
                                                                                    <Avatar>no</Avatar>}
                                                                            </Grid>
                                                                            <Grid item style={{
                                                                                marginTop: 12,
                                                                                marginLeft: 10
                                                                            }}>
                                                                                {textMaxSize(row.ProductName)}
                                                                            </Grid>
                                                                        </Grid>
                                                                        {tabRow.length > 1 && <Grid item xs={1}
                                                                                                    onClick={() => handleExpandTableCell(index)}>
                                                                            <TableCellDetils/>
                                                                        </Grid>}
                                                                    </Grid>
                                                                </TableCell>
                                                                <TableCell align="left"
                                                                           onClick={(e) => handleCellClick(e, row)}
                                                                           className={classes.cellFont}>
                                                                    {textMaxSize(row.ProductBarcode)}
                                                                </TableCell>
                                                                <TableCell align="left"
                                                                           onClick={(e) => handleCellClick(e, row)}
                                                                           className={classes.cellFont}>
                                                                    {textMaxSize(row.InternalId)}
                                                                </TableCell>
                                                                <TableCell align="left"
                                                                           onClick={(e) => handleCellClick(e, row)}
                                                                           className={classes.cellFont}>
                                                                    $ {textMaxSize(row.Price)}
                                                                </TableCell>
                                                                <TableCell align="left"
                                                                           onClick={(e) => handleCellClick(e, row)}
                                                                           className={classes.cellFont}>
                                                                     {textMaxSize(row.SellPrice)}
                                                                </TableCell>
                                                                <TableCell align="left"
                                                                           onClick={(e) => handleCellClick(e, row)}
                                                                           className={classes.cellFont}>
                                                                    {textMaxSize(row.Quantity)}
                                                                </TableCell>
                                                            </TableRow>
                                                            {
                                                                expand === index && tabRow.map((item, idx) => {
                                                                    return (
                                                                        <TableRow key={nanoid()}
                                                                                  style={{backgroundColor: blue[50]}}>
                                                                            <TableCell padding="checkbox"
                                                                                       onClick={(event) => handleClick(event, row.id)}>
                                                                                <Checkbox
                                                                                    checked={isItemSelected}
                                                                                    inputProps={{'aria-labelledby': labelId}}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell align="left"
                                                                                       className={classes.cellFont}>
                                                                                <Grid container>
                                                                                    <Grid item>
                                                                                        {item.ProductImageUrl ?
                                                                                            <Avatar
                                                                                                alt={item.ProductName}
                                                                                                src={item.ProductImageUrl}/> :
                                                                                            <Avatar>no</Avatar>}
                                                                                    </Grid>
                                                                                    <Grid item
                                                                                          style={{
                                                                                              marginTop: 12,
                                                                                              marginLeft: 10
                                                                                          }}>
                                                                                        {textMaxSize(item.ProductName)}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </TableCell>
                                                                            <TableCell align="left"
                                                                                       className={classes.cellFont}>
                                                                                {textMaxSize(item.ProductBarcode)}
                                                                            </TableCell>
                                                                            <TableCell align="left"
                                                                                       className={classes.cellFont}>
                                                                                {textMaxSize(item.InternalId)}
                                                                            </TableCell>
                                                                            <TableCell align="left"
                                                                                       className={classes.cellFont}>
                                                                                $ {textMaxSize(item.Price)}
                                                                            </TableCell>
                                                                            <TableCell align="left"
                                                                                       className={classes.cellFont}>
                                                                                 {textMaxSize(item.SellPrice)}
                                                                            </TableCell>
                                                                            <TableCell align="left"
                                                                                       className={classes.cellFont}>
                                                                                {textMaxSize(item.Quantity)}
                                                                            </TableCell>
                                                                            <TableCell align="left"
                                                                                       className={classes.cellFont}>
                                                                                {textMaxSize(item.ExpirationDate)}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })
                                                            }
                                                        </Fragment>

                                                    );
                                                })
                                        }
                                        {emptyRows > 0 && (
                                            <TableRow style={{height: (dense ? 33 : 53) * emptyRows}}>
                                                <TableCell colSpan={10}/>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 15, 25, 30, 50]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </>
                    )
                }

            </Paper>
        </div>
    );
}

